module.exports = __webpack_public_path__ + "static/img/icon_head1.6e5dca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_head1.png
// module id = 7I0W
// module chunks = 23